/* Bokitta PH — collection grid: when a Style filter is active, show each product card with the
   selected style's variant image + price (instead of the default featured image / min price). */
(function () {
  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/['"().,]/g, '').replace(/\s+/g, ' ').trim();
  }
  var _MF;
  function detectMoneyFmt() {
    var els = document.querySelectorAll('.price-item--regular, .price-item, .style-grid__price');
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || '').trim();
      var m = t.match(/^(\D*?)(\d[\d.,]*)(\D*)$/);
      if (m) return { pre: m[1], suf: m[3] };
    }
    return null;
  }
  function money(c) {
    var n = (Number(c) || 0) / 100;
    if (_MF === undefined) _MF = detectMoneyFmt();
    var num = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (_MF) return _MF.pre + num + _MF.suf;
    try { var code = (window.Shopify && Shopify.currency && Shopify.currency.active); if (code) return new Intl.NumberFormat('en', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).format(n); } catch (e) {}
    return num;
  }
  // variant option value -> style key -> metaobject gid (same mapping used to build the Style filter)
  var GID = {"voila": "644056711355", "voila_maxi": "644056776891", "voila_maxi_plus": "644056940731", "chic": "644057006267", "chic_maxi": "644057104571", "posh": "644057170107", "carre": "644057235643", "carre_mini": "644057333947", "freestyle_straight": "644057399483", "freestyle_crossed": "644057596091", "freestyle_binner": "644057759931", "loose_freestyle": "644057825467", "easy_jersey": "644057891003", "loose_cap_shawl": "644057989307", "loose_vogue": "644058054843", "rectangle": "644058120379", "square": "644058218683", "taj": "644058284219", "taj_maxi": "644058382523", "jolie": "644058513595", "amira_maxi": "644058579131", "snap": "644058644667", "freestyle_basic": "644058775739"};
  var OPTMAP = {"voila": "voila", "voila mini": "voila", "voila maxi": "voila_maxi", "voila maxi plus": "voila_maxi_plus", "chic": "chic", "chic mini": "chic", "chic maxi": "chic_maxi", "posh": "posh", "carre": "carre", "carre mini": "carre_mini", "freestyle straight inner": "freestyle_straight", "freestyle straight": "freestyle_straight", "freestyle crossed inner": "freestyle_crossed", "freestyle crossed": "freestyle_crossed", "freestyle b inner": "freestyle_binner", "freestyle binner": "freestyle_binner", "freestyle basic inner": "freestyle_basic", "freestyle basic": "freestyle_basic", "freestyle": "freestyle_straight", "freestyle 2 in 1 inner": "freestyle_straight", "freestyle loose": "loose_freestyle", "loose freestyle": "loose_freestyle", "easy": "easy_jersey", "easy jersey": "easy_jersey", "loose cap shawl": "loose_cap_shawl", "loose capshawl": "loose_cap_shawl", "cap shawl": "loose_cap_shawl", "loose vogue": "loose_vogue", "vogue": "loose_vogue", "rectangle": "rectangle", "rectangle double": "rectangle", "rectangle mini": "rectangle", "rectangle shawl": "rectangle", "shawl": "rectangle", "classic shawl": "rectangle", "classic chawl": "rectangle", "square": "square", "taj": "taj", "taj maxi": "taj_maxi", "amira maxi": "amira_maxi", "snap": "snap", "jolie": "jolie"};
  function keynorm(v) { return (v || '').toLowerCase().replace(/'/g, '').replace(/[()]/g, '').replace(/-/g, ' ').replace(/\s+/g, ' ').trim(); }
  function variantGid(s) { var k = OPTMAP[keynorm(s)]; return k && GID[k] ? 'gid://shopify/Metaobject/' + GID[k] : ''; }
  // The style gid(s) currently selected, read straight from the URL (set synchronously by Dawn on every change).
  function selectedGids() {
    if (!/filter\.p\.m\.custom\.style/.test(location.search)) return [];
    return new URLSearchParams(location.search).getAll('filter.p.m.custom.style');
  }
  function mainImg(card) { return card.querySelector('.card__media img'); }
  function productLinks(card) { return card.querySelectorAll('a[href*="/products/"]'); }
  function remember(card) {
    if (card.__swapInit) return;
    card.__swapInit = 1;
    var im = mainImg(card);
    if (im) card.__origImg = { src: im.getAttribute('src'), srcset: im.getAttribute('srcset'), sizes: im.getAttribute('sizes') };
    card.__origPrice = [];
    card.querySelectorAll('.price').forEach(function (pb) { card.__origPrice.push(pb.innerHTML); });
    card.__origHrefs = [];
    productLinks(card).forEach(function (a) { card.__origHrefs.push([a, a.getAttribute('href')]); });
  }
  function restore(card) {
    var im = mainImg(card);
    if (im && card.__origImg) {
      if (card.__origImg.srcset != null) im.setAttribute('srcset', card.__origImg.srcset); else im.removeAttribute('srcset');
      if (card.__origImg.sizes != null) im.setAttribute('sizes', card.__origImg.sizes);
      if (card.__origImg.src != null) im.setAttribute('src', card.__origImg.src);
    }
    if (card.__origPrice) {
      card.querySelectorAll('.price').forEach(function (pb, i) { if (card.__origPrice[i] != null) pb.innerHTML = card.__origPrice[i]; });
    }
    if (card.__origHrefs) {
      card.__origHrefs.forEach(function (pair) { if (pair[1] != null) pair[0].setAttribute('href', pair[1]); });
    }
  }
  function applyVariant(card, v) {
    var im = mainImg(card);
    if (im && v.img) {
      im.setAttribute('srcset', v.img + ' 600w');
      im.setAttribute('sizes', '600px');
      im.setAttribute('src', v.img);
      im.removeAttribute('loading');
    }
    // Point the card's links at this variant so the product page opens pre-selected on this style.
    if (v.id) {
      productLinks(card).forEach(function (a) {
        var base = (a.getAttribute('href') || '').split('?')[0];
        if (base) a.setAttribute('href', base + '?variant=' + v.id);
      });
    }
    var onSale = v.cmp && v.cmp > v.price;
    card.querySelectorAll('.price').forEach(function (pb) {
      pb.querySelectorAll('.price-item--sale').forEach(function (el) { el.textContent = money(v.price); });
      pb.querySelectorAll('.price-item--regular').forEach(function (el) {
        if (el.textContent.trim() === '') return;
        el.textContent = onSale ? money(v.cmp) : money(v.price);
      });
    });
  }
  function swap() {
    var sel = selectedGids();
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var data = card.querySelector('.card-style-data');
      if (!data) return;
      remember(card);
      if (!sel.length) { restore(card); return; }
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      var match = null;
      for (var gi = 0; gi < sel.length && !match; gi++) {
        for (var i = 0; i < variants.length; i++) {
          if (variantGid(variants[i].s) === sel[gi]) { match = variants[i]; break; }
        }
      }
      if (match) applyVariant(card, match); else restore(card);
    });
  }
  var grid, obs, scheduled = false;
  function run() {
    scheduled = false;
    if (obs) obs.disconnect();
    try { swap(); } catch (e) {}
    if (obs && grid) obs.observe(grid, { childList: true, subtree: true });
  }
  function schedule() { if (scheduled) return; scheduled = true; setTimeout(run, 60); }
  function watch() {
    // Dawn REPLACES the whole product-grid SECTION (and #ProductGridContainer inside it) on each filter
    // change, so observe #MainContent, which contains the section and is never replaced.
    grid = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    if (!grid) return;
    obs = new MutationObserver(schedule);
    obs.observe(grid, { childList: true, subtree: true });
  }
  function init() {
    if (!document.querySelector('.card-style-data')) return;  // only on collection/search grids with style data
    swap();
    watch();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
})();
